import * as React from 'react'
import uuidv4 from 'uuid/v4'
import Icon from '../../Icon/Icon'

export interface IResultsStatisticsCardProps {
  title: string
  isInMark?: boolean
  text?: string[]
  guysIconCount?: number
  dynamic?: boolean
}

class ResultsStatisticsCard extends React.Component<IResultsStatisticsCardProps> {
  public constructor(props: IResultsStatisticsCardProps) {
    super(props)
  }

  public render() {
    return (
      <div className="ResultsStatisticsCard" key={uuidv4()}>
        <h5 className="ResultsStatisticsCard__title">{this.props.title}</h5>
        <div className="ResultsStatisticsCard__inner">
          {this.props.dynamic ? (
            <>
              <div className="ResultsStatisticsCard__icons">{this.createGuysIcons()}</div>
              <p className="ResultsStatisticsCard__catchphrase">{this.renderSentence()}</p>{' '}
            </>
          ) : (
            <>
              <div className="ResultsStatisticsCard__icons">
                <span className="ResultsStatisticsCard__icon">
                  <Icon name="vin" />
                </span>
                <span className="ResultsStatisticsCard__icon">
                  <Icon name="vin" />
                </span>
              </div>
              <p className="ResultsStatisticsCard__catchphrase">
                Pour limiter les risques pour votre santé,
                <em>l’alcool, c’est maximum 2 verres par jour.</em> C’est aussi{' '}
                <em>ne pas boire tous les jours</em> pour ne pas dépasser 10 verres par semaine.
              </p>
            </>
          )}
        </div>
      </div>
    )
  }

  private createGuysIcons = () => {
    const guysIconEnumeration = []
    const color = this.props.isInMark ? 'green' : 'red'

    for (let i = 0; i < 10; i++) {
      guysIconEnumeration.push(
        <span
          key={`${this.props.text}${i}`}
          className={
            i < this.props.guysIconCount
              ? `ResultsStatisticsCard__icon ResultsStatisticsCard__icon--${color}`
              : 'ResultsStatisticsCard__icon'
          }
        >
          <Icon name="men" />
        </span>
      )
    }

    return guysIconEnumeration
  }

  private renderSentence = () => {
    const result = []
    const color = this.props.isInMark ? 'green' : 'red'

    for (let i = 0; i < this.props.text.length; i++) {
      if ((this.props.text.length === 2 || this.props.text.length === 3) && i === 1) {
        result.push(
          <span
            key={uuidv4()}
            className={
              i <= this.props.guysIconCount
                ? `ResultsStatisticsCard__suggest ResultsStatisticsCard__suggest--${color}`
                : 'ResultsStatisticsCard__suggest'
            }
          >
            {this.props.text[i]}
          </span>
        )
      } else {
        result.push(this.props.text[i])
      }
    }

    return result
  }
}

export default ResultsStatisticsCard



// WEBPACK FOOTER //
// ./src/components/ResultsComponents/ResultsStatistics/ResultsStatisticsCard.tsx